import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../shared-service/http-headers.service';
import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';

@Injectable({
  providedIn: 'root'
})
export class GoogleAddressValidateService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  validateAddressAgainstGoogle(dataInput:any): Observable<any> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   return this.httpClient.post(environment.servicePath + '/address/validate', dataInput, { headers});
  }
}
